import {
  deviceSimulatorConstants,
  surveyTypesConstants,
  themeSettingsLabels,
} from "../../constants";
import { DeviceSimulator } from "../../../../shared";

const { WIZARD, WIZARD_DESKTOP } = surveyTypesConstants;
const { MACBOOK, IPHONE_X } = deviceSimulatorConstants;

const ThemePreview = ({ surveyStyle, profileData, onSurveyStyleChange }) => {
  return (
    <div className="notificationForm card shadow border-0">
      <div className="card-body p-0">
        <h5 className="px-4 py-2 mb-0">{themeSettingsLabels.EXAMPLE}</h5>
        <hr className="my-0" />
        <div className="row col-12 mx-0">
          <div className="col-xl-8 d-flex justify-content-center survey-style-types-container py-3">
            <DeviceSimulator
              deviceName={MACBOOK}
              displayType={WIZARD_DESKTOP}
              profileData={profileData}
            />
          </div>
          <div className="col-xl-4 d-flex justify-content-center survey-style-types-container py-3">
            <DeviceSimulator
              deviceName={IPHONE_X}
              displayType={WIZARD}
              profileData={profileData}
            />
            <input
              data-testid="wizard"
              type="radio"
              name="survey-style-selection"
              value={WIZARD}
              className="survey-style-radio d-none"
              onChange={onSurveyStyleChange}
              checked={surveyStyle === WIZARD}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ThemePreview;
